<template>
    <b-form @submit.prevent="Send">
        <slot 
            :instance="instance"
            :instance_original="instance_original"
            :form_errors="form_errors"
            :non_field_errors="non_field_errors"
            :render_fields="render_fields"
            :fetchState="$fetchState"
            :sending_in_process = "sending_in_process"
            />
        
        <template v-if="autobuild == true">
            

            <RestFormField 
                v-for="(f, idx) in render_fields" 
                :field="idx"
                :key="idx"/>



            <slot name="bottom">
                <b-button type="submit" variant="primary" v-if="autobuild == true"> Save </b-button>
            </slot>
        </template>
    </b-form>
</template>

<script>
    export default{
        name: 'RestForm',
        props: {
            endpoint:{
                type: String,
                default: null
            },
            load_options:{
                type: Boolean,
                default: false,
            },
            default_model_from_options:{
                type: Boolean,
                default: false,
            },
            load_instance:{
                type: Boolean,
                default: false,
            },
            reload_instance_on_success:{
                type: Boolean,
                default: false,
            },
            reload_instance_on_error:{
                type: Boolean,
                default: false,
            },            
            method:{
                type: String,
                default: 'POST',
            },
            autobuild:{
                type: Boolean,
                default: false
            },
            exclude_fields:{
                type: Array,
                default(){return []} ,
            },
            hide_fields:{
                type: Array,
                default(){return []} ,
            },
            load_instance:{
                type: Boolean,
                default: false
            },
            load_instance_method:{
                type: String,
                default: 'GET',
            },
            get_options_from_action:{
                type: String,
                default: null,
            },
            send_as_multipart_form:{
                type: Boolean,
                default: false
            },
            instance_data:{
                required: false,
                default: null,
            }
        },
        data(){
            return({
                instance:{},
                instance_original:{},
                form_errors:{},
                form_options:{},
                form_errors:{},
                sending_in_process: false,
            })
        },
        mounted(){
            if(this.instance_data != null && this.load_instance == false){
                this.instance_original = this.instance_data
                this.instance = Object.keys(this.instance_original)
                            .filter(key => !this.exclude_fields.includes(key))
                            .reduce((obj, key) => {
                                obj[key] = this.instance_original[key]
                                return obj
                            }, {})
            }
        },
        methods:{
            getAllChildComponents(component){
                let elements = Array()
                if(component.$children != undefined){
                    component.$children.forEach(child => {
                        elements.push(child)
                        elements = elements.concat(this.getAllChildComponents(child))
                    })
                }
                return elements.filter(i => {
                    return true
                })
            },
            getAxiosRequestParams(){
                let params = {
                    url: this.endpoint,
                    method: this.method,
                };
                if (this.send_as_multipart_form == true){
                    let f = new FormData()
                    Object.keys(this.instance).forEach(k=>this.instance[k] ? f.append(k, this.instance[k]): null)
                    params['data']=f
                    params['headers'] = {'Content-Type': 'multipart/form-data'}
                } else {
                    params['data'] = this.instance
                }
                return params
            },
            // Sending data
            async Send(){
                this.sending_in_process = true
                await this.$axios(this.getAxiosRequestParams())
                    .then(r => {
                        this.form_errors = {}
                        this.sending_in_process = false
                        if(this.reload_instance_on_success == true) {
                            this.loadInstance()
                        }
                        this.$emit('success', r)
                    }).catch(e => {
                        this.sending_in_process = false
                        let r = e.response
                        if(r?.status === 400){
                            this.form_errors = e.response.data
                        }
                        console.warn(e)
                        if(this.reload_instance_on_error == true) {
                            this.loadInstance()
                        }                        
                        this.$emit('error', e)
                    })
            },
            //Loading instance
            async loadInstance(){
                await this.$axios({method: this.load_instance_method, url: this.endpoint})
                    .then(r=> {
                        
                        this.instance_original = r.data
                        this.instance = Object.keys(r.data)
                            .filter(key => !this.exclude_fields.includes(key))
                            .reduce((obj, key) => {
                                obj[key] = r.data[key]
                                return obj
                            }, {})

                        console.warn(data_filtered)

                        //this.instance = r.data
                        this.$emit('instance_loaded', this.instance)
                    })
                    .catch(e => {})
            },
            async loadOptions(){
                await this.$axios.$options(this.endpoint)
                    .then((r)=>{
                        this.form_options = r

                        // creating default model from options
                        if(this.default_model_from_options == true || this.autobuild == true){
                            this.instance = this.getDefaultModel()
                        }
                        this.$emit('options_loaded', this.form_options)
                    })
                    .catch((e)=>{console.log(e)})
            },
            getFields(){
                if(this.form_options.actions){
                    let method
                    if(this.get_options_from_action == null){
                        method = this.method.toUpperCase()
                    }else{
                        method = this.get_options_from_action.toUpperCase()
                    }
                    
                    let fields = this.form_options.actions[method]

                    if(fields !== undefined){
                        let filtered_fields = {}
                        Object.keys(fields).forEach(f=>{
                            if(!this.exclude_fields.includes(f)){
                                filtered_fields[f] = fields[f]
                            }
                        })
                        return filtered_fields
                    }else{
                        console.error(`Error: Can't find ${method} in actions. Maybe this endpoint does not support ${method}`)
                        return {}
                    }
                }
                return {}
            },
            getDefaultModel(){
                if(this.form_options.actions){
                    let fields = this.getFields();
                    let model = {}
                    Object.keys(fields).forEach(k => {
                        model[k] = null
                    })
                    return model
                }
            },
        },
        computed:{
            render_fields(){
                let filtered={}
                let fields = this.getFields()

                Object.keys(fields).forEach(k=>{
                    if(!this.hide_fields.includes(k)){
                        filtered[k] = fields[k]
                    }
                })
                return filtered
            },
            field_states(){
                let states={}
                Object.keys(this.form_errors)
                    .forEach(k=>{ states[k] = this.form.form_errors[k] == undefined })
                return states
            },
            field_invalid_feedbacks(){
                let feedbacks={}
                Object.keys(this.form_errors)
                    .forEach(k=>{ feedbacks[k] = this.form.form_errors[k] })
                return feedbacks
            },
            non_field_errors(){
                if(this.form_errors.non_field_errors){
                    return this.form_errors.non_field_errors
                }
                return null
            },
        },
        // Fetching data
        async fetch(){
            var promise_options = (this.load_options && this.endpoint) || (this.autobuild == true && this.endpoint) ? this.loadOptions() : Promise.resolve()
            var promise_instance = this.load_instance ? this.loadInstance() : Promise.resolve()
            
            await Promise.all([promise_options, promise_instance])
                .then(()=>{
                    this.$emit('fetch_completed')
                })
        }
    }
</script>
